import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SessionStore } from '../state/session.store';
import { LoadingIndicatorService } from '../services/loading-indicator.service';
import { InterceptorHeaders } from '../constants/interceptor-headers';

const SESSION_TRACE_ID = crypto.randomUUID();

export const requestInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionStore);
  const loading = inject(LoadingIndicatorService);

  const showLoading = !req.url.includes('/auth/access_token/refresh/');

  let headers = req.headers
    .set(InterceptorHeaders.ACCEPT_LANGUAGE, session.language().toUpperCase())
    .set(InterceptorHeaders.X_CORRELATION_ID, crypto.randomUUID())
    .set(InterceptorHeaders.X_TRACE_ID, SESSION_TRACE_ID);

  if (!headers.has('Accept')) {
    headers = headers.set('Accept', req.responseType === 'json' ? 'application/json' : '*/*');
  }
  const isFormData = req.body instanceof FormData;
  if (!isFormData && !headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  } else if (isFormData) {
    headers = headers.delete('Content-Type');
  }
  const token = session.accessToken();
  if (token && !headers.has('Authorization')) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  if (showLoading) {
    loading.increment();
  }

  return next(req.clone({ headers })).pipe(
    finalize(() => {
      if (showLoading) {
        loading.decrement();
      }
    }),
  );
};
